import type NumberUnit from '@exodus/currency';
import { formatAssetAmount } from '@exodus/formatting/lib/asset';
import type { Asset } from '@passkeys/assets';
import Text from '@passkeys/ui/text';
import { useMemo } from 'react';

type RemainingBalanceProps = {
  asset: Asset;
  amount?: NumberUnit;
  availableBalance: NumberUnit;
};

function RemainingBalance({
  asset,
  amount,
  availableBalance,
}: RemainingBalanceProps) {
  const remainingBalance = useMemo(() => {
    let result = availableBalance;

    if (amount) {
      result = availableBalance.sub(amount).clampLowerZero();
    }

    return result;
  }, [amount, availableBalance]);

  return (
    <div className="flex justify-between">
      <Text
        monospace
        size={13}
        className="text-black/50 theme-dark:text-white/50"
      >
        Remaining Balance
      </Text>
      <Text
        monospace
        size={13}
        className="text-black/50 theme-dark:text-white/50"
      >
        {formatAssetAmount(remainingBalance)} {asset.displayTicker}
      </Text>
    </div>
  );
}

export default RemainingBalance;
